import request from '@/utils/request'
const api = {
  /** ******* 系统管理 start ***********/

  /* 权限管理-项目数据权限 */
  getDepartmentTree: '/sysmgmt/department/children', // 获取组织架构
  getProgramTree: '/bm/department/children', // 获取全部项目的树结构
  getProjectAuthTree: '/sysmgmt/department/getProjectAuth', // 获取倍授权的项目code集合
  authProject: '/sysmgmt/department/authProject', // 项目授权组织机构

  /* 权限管理-物理归属 */
  belongList: '/sysmgmt/department/belong', // 物理归属列表
  setBelong: '/sysmgmt/department/setBelong', // 设置物理归属
  /* 岗位管理 */
  postList: '/sysmgmt/post/list', // 获取岗位列表
  authRole: '/sysmgmt/post/authRole', // 岗位授权角色
  /** ******* 系统管理 end ************/

  /** ******* 工单中心 start ************/
  /* 工作台&工单流转 */
  orderList: '/order/list', // 工单中心列表
  listCount: '/order/list/count', // 工单中心首页列表计数
  detailZC: '/orderdetail/select/zc', // 自查工单详情
  getLabels: '/flow/labels', // 获取问题标签
  getBigReasonList: '/order/bigFlowCategory/tree', // 获取原因大类列表
  getSmallReasonList: '/order/smallFlowCategory', // 获取原因细类列表
  gethandlerUsers: '/flow/handlerUsers', // 获取处理人
  OrderFlow: '/flow/handle/order', // 工单流转
  /* 工单创建 */
  createWork: '/order/create', // 创建自查类工单
  getPublicAreaList: '/bm/publicarea/list', // 查询项目下的分类及公区树
  addrOrderList: '/order/addrOrderList', // 获取位置工单列表
  gethandler: '/order/handler', // 新建工单时获取处理人
  deviceType: '/bm/facility/category/list', // 获取设施设备分类
  deviceList: '/bm/facility/list', // 获取设施设备列表

  /* 配置管理-原因类型配置 */
  updateNextFiled: '/flow/category/updateNextFiled', // 更新下级
  categoryList: '/flow/category/list', // 原因类型列表
  updateStatus: '/flow/category/updateStatus', // 修改原因类型状态
  // categoryUpdate: '/flow/category/update', // 修改原因类型
  categoryUpdate: '/flow/category/v2/update', // 修改原因类型
  categoryTree: '/flow/category/tree', // 原因类型树形
  // categoryDel: '/flow/category/delete', // 删除原因类型
  categoryDel: '/flow/category/v2/delete', // 删除原因类型
  // createReason: '/flow/category/create', // 新增原因类型
  createReason: '/flow/category/v2/create', // 新增原因类型
  // categoryDetail: '/flow/category/detail', // 原因类型详情
  categoryDetail: '/flow/category/v2/detail', // 原因类型详情
  workDetail: '/order/select/zc', // 工单详情
  detailConcern: '/order/attention', // 关注/取消关注
  cuiban: '/flow/handle/orderCb',
  /** ******* 工单中心 end ************/

  // 流转配置
  movingDel: '/flow/template/delete/', // 删除流转配置
  getMovingNodeList: '/flow/node/findlist', // 获取节点列表
  movingAddNode: '/flow/node/create', // 新增节点
  movingUpdateNode: '/flow/node/update', // 更新节点
  movingSetstate: '/flow/template/setstate', // 设置状态
  movingAddBaseinfo: '/flow/template/create', // 新增流转配置基本信息
  movingEditBaseinfo: '/flow/template/update', // 修改配置基本信息
  movingAddNodeConfig: '/flow/route/create', // 新增节点配置
  getNodeList: '/flow/node/findlist', // 获取节点列表
  getNodeConfig: '/flow/route/list', // 查询节点配置列表
  movingCopy: '/flow/template/copy/', // 流转配置复制
  // 通用接口
  getOssParams: '/order/oss/detail', // 获取上传文件oss参数
  getUserMenu: '/sysmgmt/permission/user/tree', // 获取用户权限菜单
  // 工单跟踪
  getProjectList: '/bm/department/mylist', // 查询登陆人所属的项目树
  getAllProjectList: '/bm/department/mypclist', // 查询登陆人所属的项目树
  getTrackList: '/order/followlist', // 获取列表数据
  getTrackStatus: '/order/followstatus', // 获取状态数据
  exportTrack: '/order/followDown', // 导出列表数据

  // 配置管理-模板配置
  getTemplateTypeList: '/order/template/list', // 获取类型下面的字段配置
  getTemplateTypeDetail: '/order/template/findById/', // 获取类型下面的字段配置详情
  addTemplateTypeList: '/order/template/create', // 新增类型下面的字段配置
  putTemplateTypeList: '/order/template/update', // 修改类型下面的字段配置
  delTemplateTypeList: '/order/template/delete/', // 删除类型下面的字段配置

  // 获取所有字典组数据
  getAllDict: '/common/dictionary/list',

  // 1.20 接口
  getOrderDetail: '/orderdetail/select/pcrw', // 新订单详情
  getProblemList: '/orderdetail/select/wtrw', // 获取问题列表
  getFileData: '/orderdetail/select/rwxfj',

  // 品控接口
  getTaskList: '/order/list', // 任务管理列表
  getTaskListCount: '/orderTask/counts', // 任务管理列表
  handleClose: '/cancel', // 取消任务管理
  handleSelect: '/handlerSelect', // 获取任务处理人
  roleAllUser: '/order/roleAllUser', // 任务管理-任务处理人
  handleChangeSelect: '/changeHandlerSelect', // 取消任务管理
  getDict: '/dic/allList', // 取消任务管理
  handleChange: '/change' // 变更
}
export default api

export function exportTrackApi(url, data) {
  return request({
    url: url,
    method: 'get',
    responseType: 'arraybuffer',
    data: data,
    headers: {
      'Content-Type': 'application/json; application/octet-stream'
    }
  })
}

// 获取工单详情
export function getWorkDetail(data) {
  return request({
    url: '/orderdetail/select/pcrw',
    method: 'get',
    params: data,
  })
}
